import { BaseComposeModal } from '@/components/BaseComposeModal'

interface ComposeModalProps {
    isOpen: boolean
    onClose: () => void
}

export function ComposeModal({ isOpen, onClose }: ComposeModalProps) {
    return <BaseComposeModal isOpen={isOpen} onClose={onClose} />
}
